module.exports = __webpack_public_path__ + "static/img/home_banner_5.d773c239.jpg";